<template>
  <div class="ruleDetailData" style="padding: 0 20px 20px">
    <vxe-toolbar>
      <template #buttons>
        <el-button size="small" type="primary" @click="insertEvent()">新增</el-button>
        <el-button size="small" @click="removeEvent()">删除</el-button>
        <el-button size="small" type="primary" @click="showDefaultRulesDialog()">规则库选择</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      border
      resizable
      highlight-hover-row
      ref="xTable"
      max-height="600"
      :data="ruleDetailData"
      :sort-config="{ trigger: 'cell' }"
      :edit-config="{
        trigger: 'click',
        mode: 'cell',
        showStatus: true,
        icon: 'fa fa-pencil'
      }"
      @edit-closed="editClosedEvent"
    >
      <vxe-column type="checkbox" width="60"></vxe-column>
      <vxe-column type="seq" width="60"></vxe-column>
      <vxe-column width="10%" field="riskLevel" title="风险等级" align="center" :edit-render="{}">
        <template #default="{ row }">
            <span>
              {{ formatRiskLevel(row.riskLevel) }}
            </span>
        </template>
        <template #edit="{ row }">
          <vxe-select v-model="row.riskLevel" transfer>
            <vxe-option v-for="item in riskLevels" :key="item.value" :value="item.value" :label="item.label"></vxe-option>
          </vxe-select>
        </template>
      </vxe-column>
      <vxe-column width="30%" field="ruleName" title="条款名称" :edit-render="{}">
        <template #edit="{ row }">
          <vxe-textarea v-model="row.ruleName" type="text" rows="5" ></vxe-textarea>
        </template>
      </vxe-column>
      <vxe-column field="ruleDesc" title="条款规则" :edit-render="{}">
        <template #edit="{ row }">
          <vxe-textarea v-model="row.ruleDesc" type="text" rows="5"></vxe-textarea>
        </template>
      </vxe-column>
    </vxe-table>
    <!-- 流程选择对话框  -->
    <default-rules-dialog ref="defaultRulesDialog" name="defaultRulesDialog" @onConfirm="selectRules" append-to-body />
  </div>
</template>

<script>
import form from '@/api/form'
import req from '@/request'
import { mapState } from 'vuex'
import dictUtils from '@/utils'
const defaultRulesDialog = () => import('./defaultRulesDialog.vue')

export default {
  components: {
    defaultRulesDialog
  },
  name: 'ruleConfigTable',
  data() {
    return {
      record: {
        ruleName: '',
        ruleDesc: '',
        riskLevel: '',
        refId: this.rulesData.id
      },
      riskLevels:[
        { value: 'high', label: '高风险' },
        { value: 'medium', label: '中风险' },
        { value: 'low', label: '低风险' }
      ]
    }
  },
  props: {
    rulesData:{
      type: Object,
      default: () => {}
    },
    ruleDetailData:{
      type: Array,
      default: () => []
    },
    isEdit: {
      type: Boolean,
      default: () => false
    }
  },
  mounted() {
    // console.log(this.ruleDetailData)
    if (!this.isEdit) {
      this.ruleDetailData = []
    }
  },
  methods: {
    insertEvent(row) {
      this.record = {
        ruleName: '',
        ruleDesc: '',
        riskLevel: '',
        refId: this.rulesData.id
      }
      this.ruleDetailData.push(this.record)

    },
    removeEvent() {
      this.$refs.xTable.removeCheckboxRow()
      this.$emit('dataChange', this.$refs.xTable.getTableData().fullData)
    },
    editClosedEvent({ row, column }) {
      const $table = this.$refs.xTable
      const field = column.property
      // 判断单元格值是否被修改
      if ($table.isUpdateByRow(row, field)) {
        setTimeout(() => {
          // 局部更新单元格为已保存状态
          $table.reloadRow(this.record, null, field)
        }, 300)
      }
    },
    formatRiskLevel(value) {
      let riskLevel = this.riskLevels.find((item) => item.value === value)
      return riskLevel ? riskLevel.label : ''
    },
    showDefaultRulesDialog() {
      this.$refs.defaultRulesDialog.showDialog()
    },
    selectRules(selectDatas) {
      // console.info(selectDatas)
      selectDatas.forEach(item => {
        item.id = null;
        item.refId = this.rulesData.id
        this.ruleDetailData.push(item)
      });
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.vxe-dropdown--panel {
  z-index: 2010 !important;
}
//日期框
.vxe-input--panel.type--date,
.vxe-input--panel.type--month,
.vxe-input--panel.type--week,
.vxe-input--panel.type--year {
  z-index: 9998 !important;
}
//选择框
.vxe-select--panel {
  z-index: 9997 !important;
}
.vxe-table--tooltip-wrapper {
  z-index: 9999 !important;
}
.vxe-dropdown--panel {
  z-index: 2010 !important;
}
</style>
